<button mat-icon-button edPrivacyConsentDialog matTooltip="Privacy Consent" i18n-matTooltip>
  <mat-icon>cookie</mat-icon>
</button>
